import { Checkbox, Drawer, message, Spin } from "antd";
import closeIcon from "assets/closeIconWhite.png";
import "../register/customize.css";
import { useRechargeModel } from "./util";
import "./customize.css";
import styled from "@emotion/styled";
import { GiftContent, TipContent } from "./contant";
import { getLanguage } from "auth-provider";
import { LabelType, PageHeader } from "../register/page-header";
import { useReducer, useState, useCallback, useEffect, useRef, useMemo } from "react";
import { DisplayText, ThemeText } from "components/lib";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import { LinkText } from "screens/register/page-register";
import backIcon from "assets/backIcon.png";
import { RestaurantConfig } from "screens/register/contant";
import { LinkArrow } from "./resturant-notify";
import { PayButton } from "./pay-button";
import { v4 as uuidv4 } from "uuid";
import { POS_API_URL, useHttp } from "utils/http";
import { useAuth } from "context/auth-context";
import { LoyaltyMember, Recharge } from "./reataurant-card";
import { LoadingOutlined } from "@ant-design/icons";
import { getHeaders, POS_HEADERS } from "utils/request";
import { PayAgreement } from "./pay-agreement";
import {
  MIX_PANEL_EVENT,
  trackMixPanel,
  useTrackCommonData,
} from "mixpanel/mixpanelTrackUtil";
import React from "react";
import { getLoyaltyMemberJoinStatus } from "utils";
import { JoinMemberMode, RechargeType } from "types/joinAsMemberMode";
import { GuestInfo } from "./draw-gift";


// function getRechargeAvailableRestrictDaysDesc(lang: LabelType, recharge_available_restrict_days: number) {
//   if (recharge_available_restrict_days) {
//     return <React.Fragment>
//       {
//         lang === 'en' && <React.Fragment>
//           {`Credits will be available after `}
//           <span style={{ color: '#E00051' }}>&nbsp;{recharge_available_restrict_days}&nbsp;</span>
//           {' days'}
//         </React.Fragment>
//       }
//       {
//         lang === 'zh' && <React.Fragment>
//           {`充值金额`}
//           <span style={{ color: '#E00051' }}>{recharge_available_restrict_days}</span>
//           {'天后可用'}
//         </React.Fragment>
//       }
//     </React.Fragment>
//   } else {
//     return <React.Fragment>
//       {
//         lang === 'en' && 'Recharge will not expire'
//       }
//       {
//         lang === 'zh' && '充值不会过期'
//       }
//     </React.Fragment>;
//   }
// }

export const DrawAnnualFeeRecharge = ({
  refresh,
  ...props
}: {
  setPayStatus: (val: string, rechargeType: RechargeType) => void;
  changeLang: (val: LabelType) => void;
  rechargeList: Recharge[];
  maxAmount: number;
  refresh: number;
  restaurantInfo: { phoneNumber: string; memeberId: string; username: string };
  loyaltyMember: LoyaltyMember;
}) => {
  const client = useHttp();
  const trackCommonData = useTrackCommonData();

  const lang = getLanguage() as LabelType;

  const { restaurant: restaurantData, disountData, restaurantGroupInfo } = useAuth();

  const [readStatus, setReadStatus] = useState(true);
  const [rechargeId, setRechargeId] = useState("");
  const [isCreateLoading, setIsCreate] = useState(false);
  const [reCount, setReCount] = useState(0);

  const [curOrderId, setOrderId] = useState("");
  const [paymentId, setPaymentId] = useState("");
  const [curOrderAmount, setOrderAmount] = useState(0);
  const [orderNumber, setOrderNumber] = useState('');
  const [msgCount, setMsgCount] = useState(0);
  // const [bottomVisible, setBottomVisible] = useState(true);
  // const [sHeight, setSHeight] = useState(0);

  const contentRef = useRef(null);

  const { reCharge, forAnnual, closeRecharge, openRecharge } = useRechargeModel();
  const [annualFeeChargeMode, setAnnualFeeChargeMode] = useState(false);

  let { joinMemberMode, annualFeeAmount, annualFeeDealId, annualJoinModeActived, annualJoinModeExpiredActived } = useMemo(() => {
    return getLoyaltyMemberJoinStatus(props.loyaltyMember, disountData);
  }, [props.loyaltyMember, disountData]);




  const handleClose = () => {
    if (reCharge === "agreement") {
      openRecharge("open", forAnnual);
    } else {
      setRechargeId("");
      closeRecharge();
    }
  };

  const closeDialog = () => {
    trackMixPanel(MIX_PANEL_EVENT.PREPAY_CLOSE, trackCommonData);
    handleClose();
  };

  const resetData = useCallback(() => {
    setRechargeId("");
    setIsCreate(false);
    setOrderAmount(0);
  }, []);

  const [guestInfo, disGuestInfo] = useReducer(
    (state: GuestInfo, action: Partial<GuestInfo>) => ({ ...state, ...action }),
    {
      name: "",
      id: "",
      phone: "",
      avatar: "",
      loyalty_member_id: "",
      email: "",
    }
  );

  useEffect(() => {
    // 清空选项
    resetData();
    if (forAnnual && joinMemberMode === JoinMemberMode.annual_fee_join) {
      setAnnualFeeChargeMode(true);
      handleSelPlan(annualFeeDealId);
    }
    // eslint-disable-next-line
  }, [refresh, resetData, reCount, annualJoinModeActived, annualJoinModeExpiredActived, forAnnual]);

  const handleChangeCheck = (e: CheckboxChangeEvent) => {
    const agreementStatus = e.target.checked || false;
    setReadStatus(agreementStatus);
  };

  const handleClickAgreement = () => {
    openRecharge("agreement", forAnnual);
  };

  const handleSelPlan = (id: string | undefined) => {
    if (isCreateLoading || !id || id === rechargeId) return;
    setRechargeId(id);
    createPayOrder(id);
    trackMixPanel(MIX_PANEL_EVENT.PREPAY_CLICK_PAY_LIST, trackCommonData);
  };

  const setUuid = () => {
    const orderId = uuidv4();
    const guestId = uuidv4();
    const paymentId = uuidv4();

    setPaymentId(paymentId);

    return {
      orderId,
      guestId,
    };
  };

  const createPayOrder = async (deal_id: string) => {
    try {
      // 创建pay order 时，下面加上遮罩
      const loyaltyMember = props.loyaltyMember;
      const { orderId, guestId } = setUuid();
      const guestInfoTmp = {
        name: loyaltyMember.userName,
        id: guestId,
        phone: loyaltyMember.phoneNumber,
        avatar: "", // 无
        loyalty_member_id: loyaltyMember.memberId,
        email: "", // 无
      };
      disGuestInfo(guestInfoTmp);
      // todo： 这里要加 try catch
      setIsCreate(true);
      const result = await client(`${POS_API_URL}/api/v1/order/${orderId}`, {
        method: "post",
        headers: getHeaders(POS_HEADERS),
        data: {
          deal_id: deal_id,
          id: orderId,
          service_type: "other", // 是否固定
          restaurant_id: restaurantData.data.id,
          order_source: "loyalty", // 是否正确
          guests: [guestInfoTmp],
          ... (restaurantGroupInfo ? {
            restaurant_group_id: restaurantGroupInfo.id,
          } : {})
        },
      });
      setIsCreate(false);
      // 获取需要支付的值，给stripe
      if (result?.total) {
        setOrderId(result.id);
        setOrderAmount(result.total);
        setOrderNumber(result.order_number);
        return;
      }
    } catch (error) {
      // 支付接口错误，给出提示
      message.error(TipContent.errorTip[lang]);
      setRechargeId("");
      setIsCreate(false);
      setOrderAmount(0);
    }
  };

  const checkStatusMsg = useCallback(() => {
    if (!readStatus) {
      if (!msgCount) {
        message.info(TipContent.unread[lang]).then(() => {
          setMsgCount(0);
        });
        setMsgCount(1);
      }
      return false;
    } else if (!rechargeId) {
      if (!msgCount) {
        message.info(TipContent.unsel[lang]).then(() => {
          setMsgCount(0);
        });
        setMsgCount(1);
      }
      return false;
    } else if (curOrderAmount <= 0) {
      if (!msgCount) {
        message.info(TipContent.amountError[lang]).then(() => {
          setMsgCount(0);
        });
        setMsgCount(1);
      }
      return false;
    } else {
      return true;
    }
  }, [readStatus, rechargeId, lang, msgCount, curOrderAmount]);

  // 获取高度
  const getHeight = () => {
    const ele = contentRef.current;
    if (!ele) {
      return;
    }
    // scrollHeight vs clientHeight

  };

  useEffect(() => {

  }, [props.rechargeList, reCharge]);

  // Update 'width' and 'height' when the window resizes
  useEffect(() => {
    window.addEventListener("resize", getHeight);
    return () => {
      window.removeEventListener("resize", getHeight);
    };
  }, []);

  return (
    // forceRender={true} 解决useForm无元素挂载的问题
    <Drawer
      forceRender={false}
      visible={!!reCharge && annualFeeChargeMode}
      placement={"bottom"}
      width={"100vw"}
      height={reCharge === 'agreement' || !annualFeeChargeMode ? '100%' : 'auto'}
      closable={false}
      style={{ padding: 0, borderRadius: "1.2rem 1.2rem 0 0" }}
      bodyStyle={{ padding: 0 }}
      className={`drawClass ${annualFeeChargeMode ? 'drawAnnualClass' : ''}`}
    >
      <DrawTitle>
        <PageHeader showLangSwicth={false}
          changeLang={props.changeLang}
          styleObj={{ padding: 0, borderBottom: "none" }}
        >
          {reCharge === "agreement" ? (
            <LinkArrow onClick={handleClose}>
              <img
                src={backIcon}
                alt={"back png"}
                style={{
                  width: "0.6rem",
                  height: "1.4rem",
                  marginRight: "1.3rem",
                }}
              />
              <ThemeText fontWieght={500}>
                {RestaurantConfig.title?.[lang]}
              </ThemeText>
            </LinkArrow>
          ) : (
            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
              <CloseOutlinedBox src={closeIcon} onClick={closeDialog} />
              <ThemeText fontWieght={500} style={{ width: '100%', textAlign: 'center' }}>
                {GiftContent.annualRechargeDrawerTitle?.[lang]}
              </ThemeText>
            </div>
          )}
        </PageHeader>
      </DrawTitle>
      {reCharge === "open" && (
        <div className={"body-content"}>
          {
            annualFeeChargeMode && <AnnualRechargeWrap>
              <AnnualRechardDescDiv>
                {GiftContent.annualRechargeConfirm[lang][0]}
                <span style={{ color: '#E00051' }}>${curOrderAmount ? (curOrderAmount / 100) : Number.parseFloat(annualFeeAmount)}</span>
                {GiftContent.annualRechargeConfirm[lang][1]}
              </AnnualRechardDescDiv>
              <AnnualRechardTipsSpan>
                {
                  GiftContent.annualRechargeTips[lang]
                }
              </AnnualRechardTipsSpan>
            </AnnualRechargeWrap>
          }

          {/* 在创建时，加透明度，并且给个loading */}

          <PayWrapBox isLoading={isCreateLoading}>
            {isCreateLoading && (
              <LoadingWarpper>
                <Spin
                  indicator={
                    <LoadingOutlined
                      style={{ fontSize: "3.6rem", color: "#fff" }}
                      spin
                    />
                  }
                  size={"large"}
                ></Spin>
              </LoadingWarpper>
            )}
            <PayButton
              lang={lang}
              orderId={curOrderId}
              orderAmount={curOrderAmount}
              guestInfo={guestInfo}
              paymentId={paymentId}
              orderNumber={orderNumber}
              setPayStatus={(val: string) => props.setPayStatus(val, RechargeType.join_member_annual_fee)}
              closeDraw={() => handleClose()}
              checkStatusMsg={checkStatusMsg}
              refreshPay={() => setReCount((val) => val + 1)}
              getHeight={getHeight}

            ></PayButton>
          </PayWrapBox>
          {/* 阅读协议 */}
          <DisplayText marginVal={"1.6rem auto 0.8rem auto"}>
            <Checkbox
              checked={readStatus}
              onChange={handleChangeCheck}
              className={"checkClasses"}
            >
              <ThemeText
                fontColor={"#92929F"}
                fontSize={1.4}
                style={{ display: "inline-block" }}
              >
                {GiftContent.agreementBefore[lang]}
              </ThemeText>
              <LinkText onClick={() => handleClickAgreement()}>
                {GiftContent.agreementAfter[lang]}
              </LinkText>
            </Checkbox>
          </DisplayText>
        </div>
      )}
      {reCharge === "agreement" && <PayAgreement />}
    </Drawer>
  );
};

const DrawTitle = styled.div`
  height: 4.6rem;
  line-height: 4.6rem;
  width: 100%;
  margin-bottom: 1.2rem;
`;

const CloseOutlinedBox = styled.img`
  width: 3.6rem;
  height: 3.6rem;
`;


const PayWrapBox = styled.div<{
  isLoading: boolean;
}>`
  position: relative;
  opacity: ${(props) => (props.isLoading ? 0.6 : 1)};
`;


const LoadingWarpper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
`;



const AnnualRechargeWrap = styled.div`
  overflow: auto;
  margin-top: 5px;
  margin-bottom: 30px;
`;


// 8 - 3.4



const AnnualRechardDescDiv = styled.div`
font-style: normal;
font-weight: 400;
font-size: 24px;
line-height: 34px;
text-align:left;
color: #ffffff;
white-space:pre-line;
text-align:center;
`;

const AnnualRechardTipsSpan = styled.span`
font-style: normal;
font-weight: 400;
font-size: 15px;
line-height: 18px;
display:flex;
align-items: center;
justify-content: center;
color: #92929F;
margin-top:5px;
text-align: center;
`;
